import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IRunCreateExtractsOnWorkbooksParams extends IMultipleIdsParams {
  dsIds: string[]; // datsource ids
  encrypt: boolean;
}

export class RunCreateExtractsOnWorkbooksRequest extends Request<IRunCreateExtractsOnWorkbooksParams, IResult> {
  constructor(ids: string[], dsIds: string[], encrypt: boolean) {
    super('runCreateExtractsOnWorkbooks', {
      ids: ids,
      dsIds: dsIds,
      encrypt: encrypt

    });
  }
}
